import { OnInit, Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ReservationService } from "../../../services/reservation.service";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { ReservationSearchItem } from "../../../model/reservation-search-item";

@Component({
  selector: 'other-medical-appointment-dialog',
  templateUrl: 'other-medical-appointment-dialog.component.html',
  styleUrls: ['./other-medical-appointment-dialog.component.css']
})
export class OtherMedicalAppointmenDialogComponent implements OnInit {

  loading: boolean;
  reservationSearchItems: ReservationSearchItem[] = [];

  constructor(private reservationService: ReservationService
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<OtherMedicalAppointmenDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async ngOnInit() {
    try {
      this.loading = true;
      this.reservationSearchItems = await this.reservationService.getReservationSearchItemsForReschedule(this.data.medicalAppointmentId, this.data.sameCenter);
    }
    catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Otros turnos");
    } finally {
      this.loading = false;
    }
  }
}
